import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircleIcon, CalendarIcon, MapPinIcon, TruckIcon, CreditCardIcon } from 'lucide-react';
import { Button } from '../components/Button';
import { useOrder } from '../context/OrderContext';
export const ConfirmationPage = () => {
  const {
    orderDetails,
    confirmOrder
  } = useOrder();
  useEffect(() => {
    // Generate confirmation number on component mount
    if (orderDetails.status === 'draft') {
      confirmOrder();
    }
  }, []);
  return <div className="bg-gray-50 min-h-screen py-10" data-id="element-82">
      <div className="container mx-auto px-4" data-id="element-83">
        <div className="max-w-2xl mx-auto" data-id="element-84">
          <div className="bg-white rounded-lg shadow-md p-6 md:p-8 text-center" data-id="element-85">
            <div className="inline-block p-3 bg-green-100 rounded-full mb-6" data-id="element-86">
              <CheckCircleIcon size={48} className="text-green-600" data-id="element-87" />
            </div>
            <h1 className="text-3xl font-bold mb-2" data-id="element-88">Booking Confirmed!</h1>
            <p className="text-gray-600 mb-8" data-id="element-89">
              Your moving request has been successfully booked.
            </p>
            <div className="bg-blue-50 rounded-lg p-4 mb-8" data-id="element-90">
              <h2 className="font-bold text-lg mb-2" data-id="element-91">Confirmation Number</h2>
              <p className="text-xl font-mono" data-id="element-92">
                {orderDetails.confirmationNumber}
              </p>
              <p className="text-sm text-gray-500 mt-2" data-id="element-93">
                Please save this number for your reference.
              </p>
            </div>
            <div className="border-t border-gray-200 pt-6 mb-6" data-id="element-94">
              <h2 className="font-bold text-xl mb-4 text-left" data-id="element-95">
                Booking Details
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left" data-id="element-96">
                <div className="flex items-start" data-id="element-97">
                  <CalendarIcon className="mr-2 mt-1 text-blue-600" size={18} data-id="element-98" />
                  <div data-id="element-99">
                    <p className="font-medium" data-id="element-100">Moving Date & Time</p>
                    <p className="text-gray-600" data-id="element-101">
                      {orderDetails.moveDate},{' '}
                      {orderDetails.moveTime === 'morning' ? 'Morning (8:00 - 12:00)' : orderDetails.moveTime === 'afternoon' ? 'Afternoon (12:00 - 16:00)' : 'Evening (16:00 - 20:00)'}
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-102">
                  <TruckIcon className="mr-2 mt-1 text-blue-600" size={18} data-id="element-103" />
                  <div data-id="element-104">
                    <p className="font-medium" data-id="element-105">Vehicle Size</p>
                    <p className="text-gray-600" data-id="element-106">
                      {orderDetails.vehicleSize.charAt(0).toUpperCase() + orderDetails.vehicleSize.slice(1)}{' '}
                      Truck
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-107">
                  <MapPinIcon className="mr-2 mt-1 text-blue-600" size={18} data-id="element-108" />
                  <div data-id="element-109">
                    <p className="font-medium" data-id="element-110">Pickup Address</p>
                    <p className="text-gray-600" data-id="element-111">
                      {orderDetails.pickupAddress}
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-112">
                  <MapPinIcon className="mr-2 mt-1 text-blue-600" size={18} data-id="element-113" />
                  <div data-id="element-114">
                    <p className="font-medium" data-id="element-115">Dropoff Address</p>
                    <p className="text-gray-600" data-id="element-116">
                      {orderDetails.dropoffAddress}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="border-t border-gray-200 pt-6 mb-8" data-id="element-117">
              <h2 className="font-bold text-xl mb-4 text-left" data-id="element-118">Payment</h2>
              <div className="bg-gray-50 p-4 rounded-md mb-6" data-id="element-119">
                <div className="flex justify-between mb-2" data-id="element-120">
                  <span data-id="element-121">Total Amount</span>
                  <span className="font-bold" data-id="element-122">
                    €{orderDetails.estimatedPrice}.00
                  </span>
                </div>
                <div className="text-sm text-gray-500" data-id="element-123">
                  Payment will be collected after the move is completed.
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-124">
                <div className="border border-gray-300 rounded-md p-3 flex items-center justify-center" data-id="element-125">
                  <CreditCardIcon className="mr-2" size={18} data-id="element-126" />
                  <span data-id="element-127">Credit Card</span>
                </div>
                <div className="border border-gray-300 rounded-md p-3 flex items-center justify-center" data-id="element-128">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2" data-id="element-129">
                    <rect x="1" y="4" width="22" height="16" rx="2" ry="2" data-id="element-130"></rect>
                    <line x1="1" y1="10" x2="23" y2="10" data-id="element-131"></line>
                  </svg>
                  <span data-id="element-132">Bank Transfer</span>
                </div>
                <div className="border border-gray-300 rounded-md p-3 flex items-center justify-center" data-id="element-133">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2" data-id="element-134">
                    <circle cx="12" cy="12" r="10" data-id="element-135"></circle>
                    <line x1="12" y1="8" x2="12" y2="16" data-id="element-136"></line>
                    <line x1="8" y1="12" x2="16" y2="12" data-id="element-137"></line>
                  </svg>
                  <span data-id="element-138">Cash</span>
                </div>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-139">
              <Link to="/tracking" data-id="element-140">
                <Button variant="primary" data-id="element-141">Track Your Order</Button>
              </Link>
              <Link to="/" data-id="element-142">
                <Button variant="outline" data-id="element-143">Back to Home</Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>;
};